import React from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
type DisclosureProps = {
  id: string;
  isOpen: boolean;
  onToggle: () => void;
  header: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  iconClassName?: string;
};
export function Disclosure({
  id,
  isOpen,
  onToggle,
  header,
  children,
  className = '',
  iconClassName = 'text-moss-600'
}: DisclosureProps) {
  const reduceMotion = useReducedMotion();
  return <div className={className} data-id="element-47" data-mp="2reub4ele1g71">
      <button type="button" onClick={onToggle} aria-expanded={isOpen} aria-controls={id} className="flex w-full items-center gap-3 py-4 text-left transition-transform duration-150 ease-out active:scale-[0.99] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-forest-800" data-id="element-48" data-mp="2re2csw0ep4d2">
        <span className="min-w-0 flex-1" data-id="element-49" data-mp="28m9mj9cq1x91">{header}</span>
        <ChevronDownIcon aria-hidden="true" className={`h-5 w-5 shrink-0 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''} ${iconClassName}`} data-id="element-50" data-mp="36vx9tzg24gv8" />
      </button>
      <AnimatePresence initial={false} data-id="element-51" data-mp="2y2tol4z66zq1">
        {isOpen && <motion.div id={id} initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: reduceMotion ? 0 : 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="overflow-hidden" data-id="element-52" data-mp="2t4jtsvhcy14y">
            <div className="pb-5" data-id="element-53" data-mp="2f3zaly7j63ax">{children}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}